import { FC } from 'react'

import type { Scope } from '@sentry/react'

import App from 'app/App'
import DraftContextProvider from 'contexts/DraftContext'
import FileUploadContextProvider from 'contexts/FileUploadContext/provider'

import { PeachOverrides, Spinner } from 'core/components'
import { ErrorMessage } from 'core/components/lib/ErrorBoundary/defaultErrorBoundaries'
import { addToast, fetchBootstrap, useBootstrapStore } from 'core/stores'
import ToastViewport from 'core/stores/toasts/ToastViewport'
import ErrorLogging from 'core/system/ErrorLogging'
import { useErrorLoggingScope } from 'core/system/useErrorLoggingScope'

import CommonProviders from './CommonProvider'
import useActivityRenewal from './session/useActivityRenewal'

void fetchBootstrap()

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  ErrorLogging.withScope((scope: Scope) => {
    scope.setTag('ident', 'UnhandledExceptions')
    ErrorLogging.captureException(event.reason)
  })
  addToast(<ErrorMessage error={event.reason} />, 'error')
})

const Root: FC = () => {
  const bootstrap = useBootstrapStore()
  const { appDomainType, userType, company } = bootstrap ?? {}

  useErrorLoggingScope({ company, appDomainType, userType })

  useActivityRenewal()

  return (
    <>
      {bootstrap === null ?
        <>
          <ToastViewport />
          <Spinner height='100vh' />
        </>
      : <CommonProviders>
          <>
            <ToastViewport />
            <DraftContextProvider>
              <FileUploadContextProvider>
                <App />
                <PeachOverrides />
              </FileUploadContextProvider>
            </DraftContextProvider>
          </>
        </CommonProviders>
      }
    </>
  )
}

export default Root
